export default {
    path: '/distribution',
    name: 'distribution',
    component: () => import('@/views/distribution/index.vue'),
    children: [
        {
            path: 'storeactivities',
            name: 'storeactivities',
            component: () => import('@/views/distribution/store-activities/index.vue'),
            meta: {
                pageTitle: '门店活动',
            },
        },
        {
            path: 'storeactivities/entrance/:id',
            name: 'storeactivities/entrance',
            component: () => import('@/views/distribution/store-activities/tabs/entrance/add.vue'),
            meta: {
                parent: '/distribution/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动入口  / 编辑',
            // }
        },
        {
            path: 'storeactivities/configure/:id',
            name: 'storeactivities/configure',
            component: () => import('@/views/distribution/store-activities/tabs/configure/add.vue'),
            meta: {
                parent: '/distribution/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动配置  / 编辑',
            // }
        },
        {
            path: 'storeactivities/record/:id',
            name: 'storeactivities/record',
            component: () => import('@/views/distribution/store-activities/tabs/record/detail.vue'),
            meta: {
                parent: '/distribution/storeactivities',
            }
            // meta: {
            //     pageTitle: '门店活动 / 活动记录  / 查看',
            // }
        },
        {
            path: '/distribution/storeSale',
            name: 'storeSale',
            component: () => import('@/views/distribution/storeSale/index.vue'),
            meta: {
                pageTitle: '门店售卖',
            }
        }
    ]
}